import {
    useMemo,
    useRef,
    type FC
} from "react";
import {
    View
} from "react-native";
import type INavigationMenuItemProps from "./type";
import stylesheet from "./stylesheet";
import {
    NavigationMenuItemContext,
    useNavigationMenuContext
} from "../../context";
import {
    getNavigationMenuHasContent,
    getNavigationMenuItemKey
} from "../../util";
import NavigationMenuTrigger from "../trigger";

const NavigationMenuItem: FC<INavigationMenuItemProps> = ({
    isDisabled = false,
    isActive = false,
    customTheme,
    children,
    onPress,
    title,
    value,
    href
}) => {
    const context = useNavigationMenuContext({
        part: "Item"
    });

    const anchorRef = useRef<View>(null);

    const itemKey = getNavigationMenuItemKey({
        title,
        value,
        href
    });

    const hasContent = getNavigationMenuHasContent({
        children,
        href
    });

    const itemContext = useMemo(() => ({
        value: itemKey,
        anchorRef
    }), [
        itemKey
    ]);

    if(!context) {
        return null;
    }

    return <View
        style={stylesheet.item}
        role="listitem"
        ref={anchorRef}
    >
        <NavigationMenuTrigger
            customTheme={customTheme}
            hasContent={hasContent}
            isDisabled={isDisabled}
            isActive={isActive}
            itemKey={itemKey}
            onPress={onPress}
            title={title}
            href={href}
        />
        <NavigationMenuItemContext.Provider
            value={itemContext}
        >
            {hasContent ? children : null}
        </NavigationMenuItemContext.Provider>
    </View>;
};
export default NavigationMenuItem;
